import * as React from "react"
import { useEffect } from "react"
import { object, string } from "yup"
import { useValidatorSeeker } from "@ui-seeker/app"

import { DIPCategory } from "@components"
import { BACKEND_APIS } from "@constants"
import { useAdminSkuForm } from "../../@hooks"
import { adminSkuFormErrors } from "../../@signals"


export default function AdminSkuFormCategory() {
    const { localValue, handleChange } = useAdminSkuForm("category")
    const { errors } = useValidatorSeeker({
        category: localValue
    }, object({
        category: string().required("Category is mandatory")
    }))

    useEffect(() => {
        adminSkuFormErrors.value = {
            ...adminSkuFormErrors.value,
            category: errors?.category
        }
    }, [errors?.category])

    return <DIPCategory
        isMultiple={false}
        urlAjax={`${BACKEND_APIS.MASTER_DATA}/category/without-customer/new-options`}
        label="Category SKU"
        placeholder="Please select a category for the SKU"
        error={errors?.category}
        value={localValue || ""}
        onChange={newValue => handleChange(newValue)}
        placement="bottomStart"
    />
}